'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('SearchPageCtrl', SearchPageCtrl);

  SearchPageCtrl.$inject = ['page', 'activityRouter', 'focus'];

  /* @ngInject */
  function SearchPageCtrl(page, activityRouter, focus) {
    var vm = this;
    vm.title = 'SearchPageCtrl';
    vm.start = activityRouter.createTrain;

    activate();

    ////////////////
    function activate() {
      vm.page = page;
      focus.byId('hero-title');
    }
  }
})();